import React from 'react';
import { Grid } from '@mui/material';
import SectionContainer from '../shared/SectionContainer';
import PathCard from '../shared/PathCard';
import { PATH_CARDS } from '../landingContent';

const ChoosePathSection = () => (
  <SectionContainer
    id="paths"
    title="Choose Your Path"
    subtitle="Whether you're hiring, job searching, or sharing your expertise — JobMockAI has a workflow built for you."
    titleId="paths-heading"
    bgcolor="#F4F7FB"
  >
    <Grid container spacing={3} alignItems="stretch">
      {PATH_CARDS.map((card) => (
        <Grid item xs={12} md={4} key={card.id}>
          <PathCard
            title={card.title}
            bullets={card.bullets}
            cta={card.cta}
            popular={card.popular}
          />
        </Grid>
      ))}
    </Grid>
  </SectionContainer>
);

export default ChoosePathSection;
